import DropDownViewModel from "../ViewModels/DropDownViewModel";

const monitoringReportDirectionOptionsDropdown: DropDownViewModel[] = [
    { label: "Arrivals", id: "0" },
    { label: "Departures", id: "1" },
    { label: "Arrivals + Departures", id: "2" }
];

export default monitoringReportDirectionOptionsDropdown;